const form = document.getElementById('category-filter-form');
if (form) {
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        const select = form.querySelector('select[name="category"]');
        const url = select.value;
        window.location.href = url;
    });
}
